import {
  withTranslation,
} from 'react-i18next';

import LoadMoreTableView from './LoadMoreTableView';
import './LoadMoreTable.css';

const TranslatedComponent = withTranslation()(LoadMoreTableView);

const Component = TranslatedComponent;

export default Component;
